import { useContext, useEffect } from 'react'
import styled from 'styled-components'
import { CreationToolsContext } from '../../../manager'
import CreationTool from '../../../types/creation-tool'
import CreationToolOutputType from '../../../types/output-type'
import CreationToolUploadField from '../../../types/upload-field'
import PrivacyField from '../../form-fields/upload/privacy'
import { CreationToolUploadContext } from '../manager'

const Privacy = styled(PrivacyField)`
    grid-column: span 4;
`

type Props = {
    className?: string
    field: CreationToolUploadField
}

const CreationUploadPrivacyField = ({ className, field }: Props) => {
    const { tool, outputType, sources } = useContext(CreationToolsContext)
    const { username, isPublic, setIsPublic } = useContext(CreationToolUploadContext)
    const outputTypeTitle = CreationToolOutputType.title(outputType)
    const privateInstructions = `Only you can see this.`
    let publicInstructions = `Anyone can see this.`

    useEffect(() => {
        setIsPublic(
            !sources.some(function (source) {
                return source.isPrivate === true
            })
        )
    }, [])

    // only display integration info if using sticker maker
    if (username && outputType === CreationToolOutputType.Sticker && tool === CreationTool.GifMaker) {
        publicInstructions += ` Searching @${username} lets you find & use this ${outputTypeTitle} in select integrations.`
    }

    return (
        <Privacy
            {...{
                className,
                field,
                isPublic: isPublic,
                instructions: isPublic ? publicInstructions : privateInstructions,
                onChange: setIsPublic,
            }}
        />
    )
}

export default CreationUploadPrivacyField
